module.exports = __webpack_public_path__ + "ui-icons_777620_256x240.png?208a290102a4ada58a04de354a1354d7";